module.exports = __webpack_public_path__ + "img/right-border.11954b2e.svg";